import { render, staticRenderFns } from "./SBText.html?vue&type=template&id=62d4b41e&scoped=true&"
import script from "./SBText.ts?vue&type=script&lang=ts&"
export * from "./SBText.ts?vue&type=script&lang=ts&"
import style0 from "./SBText.css?vue&type=style&index=0&id=62d4b41e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62d4b41e",
  null
  
)

export default component.exports